import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { deleteUserFromProject } from 'src/services/napi/users/deleteUser';
import { useNotification } from '../../../providers/notificationsProvider';

const deleteUserFn = async (userId) => {
  const currentProject = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject) return;
  const { _id: projectId } = currentProject;
  await deleteUserFromProject(projectId, userId);
};

export const useDeleteUser = ({ onError, onSuccess }) => {
  const { notify } = useNotification();

  return useMutation((userId) => deleteUserFn(userId), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
